Storage = App.loadClass 'core::Storage'

class exports.RxOptions extends Storage
    constructor: (options = {}) ->
        super()

        ###
            So this is kiiiind of a weird hack. In order to get data into the Rx angular
            controller, we need some way to access it... either pass as state params: not what
            we want, or provide some data that can be injected into the angular controller. So,
            we're adding this RxStorage object to window, so when the planting-rx state gets resolved,
            we'll yoink that object down from window, and inject it to the controller
        ###

        @store 'field', options.field.id
        @store 'field_name', options.field.field_name
        @store 'year', options.year
        @store 'crop', options.crop
        @store 'crop_name', options.crop_name
        @store 'brands', options.brands
        @store 'refuge', options.refuge
        @store 'dual_hybrid', options.dual_hybrid
        @store 'solver_variables', options.solver_variables
        # ONLY used for hackily letting us get BACK to the spp process. DON'T
        # abuse this and interact directly with the SPP from inside the Rx Plan otherwise...
        @store 'spp', options.spp
        @store 'spp_id', options.spp_id
        @store 'fsr_id', options.field.fsr_id
        @store 'yield_goal', options.yield_goal
        @store 'planter', options.planter
        @store 'from_state', options.from_state

        return this
